import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  CardWrapper,
  CardHeader,
  HeaderContent,
  CardTitle,
  ShowMoreButton,
  Divider,
  KeyStatsContainer,
  StatLabel,
  StatValue,
  StatBadge,
  NoDataMessage,
  SkeletonWrapper,
  SkeletonItem,
  SkeletonBlock,
} from "./KeyStats.styles";
import { KeyStatsModal } from "shared/StrategyOverview/Components/KeyStatsModal";

// Example icons
import { LineChartUpIcon } from "assets/icons";

const getFormattedValue = (value) => {
  if (value === "True") return "Yes";
  if (value === "False") return "No";
  return value;
};

const ICON_MAP = {
  Equity: LineChartUpIcon,
};

const KeyStats = ({ stats = [], isLoading }) => {
  const [showKeyStatsModal, setShowKeyStatsModal] = useState(false);

  const toggleViewMoreModal = () => {
    setShowKeyStatsModal((prev) => !prev);
  };

  return (
    <CardWrapper>
      <CardHeader>
        <HeaderContent>
          <CardTitle>Key Metrics</CardTitle>
          {stats?.length > 0 && (
            <ShowMoreButton onClick={toggleViewMoreModal}>
              Show more
            </ShowMoreButton>
          )}
        </HeaderContent>
        <Divider />
      </CardHeader>

      {isLoading ? (
        <KeyStatsContainer>
          <SkeletonWrapper>
            {[...Array(6)].map((_, i) => (
              <SkeletonItem key={i}>
                <SkeletonBlock width="60%" height="12px" />
                <SkeletonBlock width="40%" height="14px" />
              </SkeletonItem>
            ))}
          </SkeletonWrapper>
        </KeyStatsContainer>
      ) : stats?.length > 0 ? (
        <KeyStatsContainer>
          {stats.slice(0, 8).map((data, i) => {
            const Icon = ICON_MAP[data?.value] || null;

            return (
              <div key={i}>
                <StatLabel>{data.name}</StatLabel>

                {["Equity"].includes(data?.value) ? (
                  <StatBadge>
                    {Icon && <img src={Icon} alt="" />}
                    {data?.value}
                  </StatBadge>
                ) : (
                  <StatValue>{getFormattedValue(data?.value)}</StatValue>
                )}
              </div>
            );
          })}
        </KeyStatsContainer>
      ) : (
        <NoDataMessage>No Key Statistics found</NoDataMessage>
      )}

      {showKeyStatsModal && (
        <KeyStatsModal
          show={showKeyStatsModal}
          onHide={toggleViewMoreModal}
          stats={stats}
          getFormattedValue={getFormattedValue}
        />
      )}
    </CardWrapper>
  );
};

export default KeyStats;

KeyStats.propTypes = {
  stats: PropTypes.array,
  isLoading: PropTypes.bool,
};
